module.exports = __webpack_public_path__ + "static/media/image.ac7ed548.png";